import React from 'react';

const FormInputTreeBg = () => (
  <div
    className="position-relative"
    style={{ height: '0' }}
  >
    <div
      className="d-flex position-relative"
      style={{ height: '68px' }}
    >
      <img src="/assets/img/input-bg-left.png" alt="" />
      <div className="flex-fill">
        <img
          src="/assets/img/input-bg-center.png"
          style={{ width: '100%', height: '100%' }}
          alt=""
        />
      </div>
      <img src="/assets/img/input-bg-right.png" alt="" />
      <img
        src="/assets/img/input-tree-1.png"
        className="position-absolute"
        style={{ left: '-13px', top: '-6px', width: '36px' }}
        alt=""
      />
      <img
        src="/assets/img/input-tree-2.png"
        className="position-absolute"
        style={{ left: '-2px', top: '21px', width: '21px' }}
        alt=""
      />
      <img
        src="/assets/img/input-tree-3.png"
        className="position-absolute"
        style={{ right: '100px', top: '48px', width: '57px' }}
        alt=""
      />
      <img
        src="/assets/img/input-tree-4.png"
        className="position-absolute"
        style={{ right: '66px', top: '-7px', width: '45px' }}
        alt=""
      />
      <img
        src="/assets/img/input-tree-5.png"
        className="position-absolute"
        style={{ right: '1px', top: '6px', width: '18px' }}
        alt=""
      />
    </div>
  </div>
);

export default FormInputTreeBg;
